// extracted by mini-css-extract-plugin
module.exports = {"field":"hs17l","button":"_2kC0g","uploadAvatar":"_1OhMV","modalBox":"_1lKHv"};